import React from 'react';

/**
 * EmptyState — état vide unifié et engageant (icône ténue + titre serif + sous-titre
 * + CTA optionnel), sur le modèle de la page Courriers. À utiliser partout où une
 * liste/table peut être vide (aujourd'hui la plupart ne montrent rien).
 *
 * Props : icon (composant lucide), title, subtitle?, action? (noeud React).
 */
export default function EmptyState({ icon: Icon, title, subtitle, action }) {
  return (
    <div className="flex flex-col items-center justify-center text-center py-16 px-6" data-testid="empty-state">
      {Icon && (
        <div className="w-12 h-12 rounded-full flex items-center justify-center mb-4" style={{ background: 'var(--bg-tertiary)', border: '1px solid var(--border-color)' }}>
          <Icon className="w-5 h-5" style={{ color: 'var(--text-tertiary)' }} />
        </div>
      )}
      <div className="font-serif" style={{ fontSize: 16, color: 'var(--text-primary)' }}>{title}</div>
      {subtitle && <div className="text-[12.5px] mt-1.5 max-w-sm" style={{ color: 'var(--text-tertiary)' }}>{subtitle}</div>}
      {action && <div className="mt-5">{action}</div>}
    </div>
  );
}
